module.exports = __webpack_public_path__ + "static/media/kit.9feea241.jpg";